import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import SharePost from './SharePost';
import CreateLens from './CreateLens/CreateLens';
import DefaultPost from './DefaultPost/DefaultPost';
import VideoPost from './VideoPost/VideoPost';
import LensPost from './LensPost/LensPost';
import { fetchInventoryProducts } from '../../../../Features/inventoryManagementSlice';
import { ImageContextProvider } from '../../../../Context/ImagesContext';
import DeletePost from './DeletePost';
import ReportPost from './ReportPost/ReportPost';
import ReportComment from './ReportComment/ReportComment';

function Modal() {
    const dispatch = useDispatch();
    const activeModal = useSelector((state) => state.lens.modal.activeModal);
    const displayModal = useSelector((state) => state.lens.modal.displayModal);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if(displayModal) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [displayModal]);

    useEffect(() => {
        setTimeout(() => {
            dispatch(fetchInventoryProducts());
        }, 200);
        // eslint-disable-next-line
    }, []);

    return (
        <div className={`${visible ? 'opacity-100 visible bg-[#00000080]' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out fixed z-50 w-full h-full top-0 left-0 flex justify-center items-center`}>
            {activeModal === 'report-post' && <ReportPost />}

            {activeModal === 'report-comment' && <ReportComment />}

            {activeModal === 'share' && <SharePost />}

            {activeModal === 'create' && <CreateLens />}

            {activeModal === 'post' && <LensPost />}

            {activeModal === 'delete' && <DeletePost />}

            {
                activeModal === 'default-post' && 
                <ImageContextProvider>
                    <DefaultPost />
                </ImageContextProvider>
            }

            {
                activeModal === 'video-post' && 
                <VideoPost />
            }
        </div>
    );
}

export default Modal;
